@import ../../styles/helpers

.friendItem 
    width: 100%
    border-radius: $border_radius_medium
    padding: 11px 10px
    cursor: pointer
    &.active
        background: $chatselected
    &.simple
        .container
            justify-content: center

.infoContainer
    display: flex
    width: 100%
    justify-content: space-between
    padding-right: 10px

.Invited
    opacity: 0.5
    cursor: default

.container
    display: flex
    align-items: center
    // justify-content: space-between

.avatar
    width: $icon_size_s
    height: $icon_size_s
    position: relative
    display: flex
    justify-content: center
    align-items: center
    flex-shrink: 0
    img
        width: 100%
        height: 100%
        margin-right: 13.5px
        border-radius: 100px
    +m
        width: $icon_size_m
        height: $icon_size_m

.friendState 
    margin-left: 13.5px
    gap: 4px
    display: flex
    flex-direction: column

    &__friendName
        font-size: 19px
        line-height: 35px
        color: #ffffff
        font-weight: 500

    &__typingIndicator
        height: 20px
        font-size: 14px
        line-height: 16px
        display: flex

        &__editIcon
            width: 15px !important
            height: 15px !important
            margin-right: 8px

    &__lastMsg
        height: 20px
        font-size: 14px
        line-height: 16px

.msgState
    display: flex
    flex-direction: column
    justify-content: space-between
    margin: 0px 0px 0px 33px
    color: $dark_icon_background

    button
        color: #EC540B
        background: #FACC27
        border-radius: 100px
        padding: 10px 20px !important

    &__time
        font-size: 12px
        line-height: 14px
        display: flex
        justify-content: center
        
    &__check
        display: flex
        justify-content: flex-end
        width: 13px !important
        height: 13px
    &__unread
        background: linear-gradient(180deg, #FACD25 0%, #FFA83B 100%)
        border-radius: 13px
        
        height: 26px
        color: #11141B
        text-align: center
        font-size: 12px
        line-height: 14px
        font-weight: bold
        display: flex
        align-items: center
        justify-content: center

    .status
        font-size: 16px
        line-height: 35px
        opacity: 0.3
        color: white

        


